<template>
  <div>
    <a-modal :visible="visible" :width="600" :confirmLoading="loading" :maskClosable="false" @cancel="cancel"
      @ok="confirm">
      <div slot="title">{{ form.id ? '编辑批次' : '新建批次' }}</div>
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item prop="product_name" label="产品名称">
          <a-input v-model="form.product_name" placeholder="自定义产品名称" />
        </a-form-model-item>
        <a-form-model-item prop="batch_number" label="批号">
          <a-input v-model="form.batch_number" placeholder="批号">
            <a-button slot="addonAfter" size="small" type="link" @click="genBatchNumber">生成批号</a-button>
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="prefix" label="码前缀">
          <a-input v-model="form.prefix" placeholder="可选, 拼在溯源码最前面" allowClear />
        </a-form-model-item>
        <a-form-model-item prop="charset" label="生码规则">
          <a-select v-model="form.charset" placeholder="请选择字符集">
            <a-select-option value="alnum">数字+字母 (去混淆)</a-select-option>
            <a-select-option value="digit">纯数字</a-select-option>
            <a-select-option value="upper">大写字母</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="code_length" label="字符长度">
          <a-input-number v-model="form.code_length" :min="4" :max="32" style="width: 100%" />
          <span style="color: #999; font-size: 12px;">随机部分的长度 (4 ~ 32), 不含前缀</span>
        </a-form-model-item>
        <a-form-model-item prop="quantity" label="生码数量">
          <a-input-number v-model="form.quantity" :min="1" :max="100000" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item prop="production_date" label="生产日期">
          <a-date-picker v-model="form.production_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item prop="template" label="展示模板">
          <a-select v-model="form.template" placeholder="扫码落地页模板 (可选)" allowClear>
            <a-select-option v-for="t in templates" :key="t.id" :value="t.id">{{ t.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="remark" label="备注">
          <a-input v-model="form.remark" allowClear />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
  import { traceBatchCreate, traceBatchUpdate, traceBatchNumber } from '@/api/trace'

  export default {
    name: 'FormModal',
    props: ['visible', 'form', 'templates'],
    model: { prop: 'visible', event: 'cancel' },
    data() {
      return {
        loading: false,
        rules: {
          product_name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
          batch_number: [{ required: true, message: '请输入批号', trigger: 'blur' }],
          charset: [{ required: true, message: '请选择字符集', trigger: 'change' }],
          code_length: [{ required: true, message: '请输入字符长度', trigger: 'blur' }],
          quantity: [{ required: true, message: '请输入生码数量', trigger: 'blur' }],
        },
      };
    },
    watch: {
      visible(value) {
        if (value && !this.form.id) {
          if (this.form.charset === undefined) this.$set(this.form, 'charset', 'alnum');
          if (this.form.code_length === undefined) this.$set(this.form, 'code_length', 12);
          if (this.form.quantity === undefined) this.$set(this.form, 'quantity', 100);
        }
      },
    },
    methods: {
      genBatchNumber() {
        traceBatchNumber().then(data => {
          this.$set(this.form, 'batch_number', data.batch_number);
        });
      },
      confirm() {
        this.$refs.form.validate(valid => {
          if (!valid) return;
          this.loading = true;
          let func = this.form.id ? traceBatchUpdate : traceBatchCreate;
          func(this.form).then(data => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功');
            this.$emit(this.form.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      cancel() {
        this.$emit('cancel', false);
        if (this.$refs.form) this.$refs.form.clearValidate();
      },
    },
  }
</script>
